import type { CheckInSeason } from '../api/checkin'

// Wording for the check-in pages, kept apart from the components so it can be
// tested without rendering — a player standing in a queue needs the sentence
// to be right.

const CLOSED: Record<string, string> = {
  too_early: "Check-in hasn't opened yet. Try again closer to the start.",
  started: 'The tournament has started, so check-in here is closed. Find the desk — staff can still check you in.',
  cancelled: 'This tournament was cancelled.',
  disabled: "Check-in isn't running for this tournament right now.",
  not_open: "Check-in isn't running for this tournament right now.",
}

/** Why someone at the door can't check in right now. */
export function closedMessage(reason: string): string {
  return CLOSED[reason] ?? "Check-in isn't available right now."
}

/** "Localhost · 1 Main St", or whichever half is known. */
export function venueLine(season: Pick<CheckInSeason, 'venue_name' | 'venue_address'>): string {
  return [season.venue_name, season.venue_address].map((s) => s.trim()).filter(Boolean).join(' · ')
}

/** Where to send someone after they sign in or sign up, so they land back on this page. */
export function returnTo(path: string): string {
  return `?redirect=${encodeURIComponent(path)}`
}

/**
 * A link that opens the right door flow on the competition's page and comes back here after.
 * It goes through the league's /compete address, which forwards to the competition named.
 */
export function doorLink(season: Pick<CheckInSeason, 'id' | 'org'>, action: 'register' | 'free-agent', back: string): string {
  const q = new URLSearchParams({ season: season.id, action, return: back })
  return `/org/${season.org.slug}/compete?${q.toString()}`
}
